import React from "react";
import { formatDisplayDate } from "../utils/date";

const metricSections = [
  {
    title: "Temperature",
    fields: [
      { label: "High", valueKey: "tempHigh", unit: "°C", source: "weatherData" },
      { label: "Low", valueKey: "tempLow", unit: "°C", source: "weatherData" },
      { label: "Average", valueKey: "tempAvg", unit: "°C", source: "weatherData" },
    ],
  },
  {
    title: "Wind Speed",
    fields: [
      { label: "High", valueKey: "windspeedHigh", unit: "km/h", source: "weatherData" },
      { label: "Low", valueKey: "windspeedLow", unit: "km/h", source: "weatherData" },
      { label: "Average", valueKey: "windspeedAvg", unit: "km/h", source: "weatherData" },
    ],
  },
  {
    title: "Wind Gust",
    fields: [
      { label: "High", valueKey: "windgustHigh", unit: "km/h", source: "weatherData" },
      { label: "Low", valueKey: "windgustLow", unit: "km/h", source: "weatherData" },
      { label: "Average", valueKey: "windgustAvg", unit: "km/h", source: "weatherData" },
    ],
  },
  {
    title: "Dew Point",
    fields: [
      { label: "High", valueKey: "dewptHigh", unit: "°C", source: "weatherData" },
      { label: "Low", valueKey: "dewptLow", unit: "°C", source: "weatherData" },
      { label: "Average", valueKey: "dewptAvg", unit: "°C", source: "weatherData" },
    ],
  },
  {
    title: "Wind Chill",
    fields: [
      { label: "High", valueKey: "windchillHigh", unit: "°C", source: "weatherData" },
      { label: "Low", valueKey: "windchillLow", unit: "°C", source: "weatherData" },
      { label: "Average", valueKey: "windchillAvg", unit: "°C", source: "weatherData" },
    ],
  },
  {
    title: "Heat Index",
    fields: [
      { label: "High", valueKey: "heatindexHigh", unit: "°C", source: "weatherData" },
      { label: "Low", valueKey: "heatindexLow", unit: "°C", source: "weatherData" },
      { label: "Average", valueKey: "heatindexAvg", unit: "°C", source: "weatherData" },
    ],
  },
  {
    title: "Precipitation",
    fields: [
      { label: "Precip Rate", valueKey: "precipRate", unit: "mm/hr", source: "weatherData" },
      { label: "Precip Total", valueKey: "precipTotal", unit: "mm", source: "weatherData" },
    ],
  },
  {
    title: "Pressure",
    fields: [
      { label: "High", valueKey: "pressureHigh", unit: "mb", source: "weatherData" },
      { label: "Low", valueKey: "pressureLow", unit: "mb", source: "weatherData" },
      { label: "Average", valueKey: "pressureAvg", unit: "mb", source: "weatherData" },
    ],
  },
  {
    title: "Humidity",
    fields: [
      { label: "High", valueKey: "humidityHigh", unit: "%", source: "stationInfo" },
      { label: "Low", valueKey: "humidityLow", unit: "%", source: "stationInfo" },
      { label: "Average", valueKey: "humidityAvg", unit: "%", source: "stationInfo" },
    ],
  },
  {
    title: "Misc. Weather",
    fields: [
      {
        label: "Solar Radiation High",
        valueKey: "solarRadiationHigh",
        unit: "W/m^2",
        source: "stationInfo",
      },
      { label: "UV High", valueKey: "uvHigh", unit: "", source: "stationInfo" },
      { label: "Average Wind Direction", valueKey: "winddirAvg", unit: "°", source: "stationInfo" },
    ],
  },
];

function formatMetricValue(value, unit) {
  return value === undefined || value === null ? "N/A" : `${value}${unit ? ` ${unit}` : ""}`;
}

function renderSection(section, weatherData, stationInfo) {
  return (
    <div className="weather-group" key={section.title}>
      <div className="weather-header">
        <h4>{section.title}</h4>
      </div>
      <div className="weather-body">
        {section.fields.map((field) => {
          const source = field.source === "stationInfo" ? stationInfo : weatherData;

          return (
            <p key={field.label}>
              {field.label}: {formatMetricValue(source?.[field.valueKey], field.unit)}
            </p>
          );
        })}
      </div>
    </div>
  );
}

const WeatherDataPage = ({ weatherData, stationInfo, statusMessage }) => (
  <div className="page-content">
    <h1>Weather Data</h1>
    <h5>Current Date: {formatDisplayDate()}</h5>

    {statusMessage ? <div className="status-banner">{statusMessage}</div> : null}

    <div className="weather-container">
      {metricSections.slice(0, 6).map((section) => renderSection(section, weatherData, stationInfo))}
    </div>

    <div className="weather-container">
      {metricSections.slice(6).map((section) => renderSection(section, weatherData, stationInfo))}
    </div>
  </div>
);

export default WeatherDataPage;
